import { GetterTree } from 'vuex'
import { IPlaylistsState, IRootState } from '@/@types'

const getters: GetterTree<IPlaylistsState, IRootState> = {
  playlists: ({ playlists }) => playlists.results,
  playlistById: ({ playlistCache }) => (playlistId: String) =>
    // eslint-disable-next-line eqeqeq
    playlistCache.find(p => p.id == playlistId),
}

export default getters
